<template>
  <div :class="computedCardClass">
    <div class="mb-4 sticky top-0" v-if="card_title" :class="card_header_class">
      <h5 class="text-[1.5rem] capitalize font-bold tracking-wide">
        {{ card_title }}
      </h5>
    </div>
    <div class="overflow-visible" :class="card_body_class">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    card_title: {
      type: String,
      default: null,
    },
    card_class: {
      type: String,
      default: null,
    },
    card_header_class: {
      type: String,
      default: null,
    },
    card_body_class: {
      type: String,
      default: null,
    },
  },
  computed: {
    computedCardClass() {
      const baseClass =
        "py-2 px-3 rounded-lg border border-white/30 text-white";
      const additionalClass =
        this.card_class && this.card_class.includes("backdrop-blur")
          ? ""
          : "backdrop-blur-sm";
      return `${baseClass} ${additionalClass} ${this.card_class || ""}`.trim();
    },
  },
};
</script>
